import React from "react"

interface CtaBannerProps {
  onScrollToForm: () => void
}

export const CtaBanner: React.FC<CtaBannerProps> = ({ onScrollToForm }) => (
  <section id="contact" className="bg-emerald-500 py-20">
    <div className="max-w-[1200px] mx-auto px-6 lg:px-8 text-center">
      <h2 className="text-4xl font-black text-black mb-4">
        Ready to register your farm?
      </h2>
      <p className="text-black/70 text-lg mb-8">
        Join the national tree inventory. It's free, quick, and helps Kenya's future.
      </p>
      <button
        onClick={onScrollToForm}
        className="px-8 py-4 bg-black hover:bg-neutral-900 text-white font-bold rounded-xl transition-all hover:scale-105 active:scale-95 text-sm"
      >
        Register Your Farm Now
      </button>
    </div>
  </section>
)